import './ModalFooter.4e6976005f8342d72b3c77611e813443.css';
export default {"footer":"_footer_1n34o_1","emptyDiv":"_emptyDiv_1n34o_1","actions":"_actions_1n34o_1","additionalFooterContent":"_additionalFooterContent_1n34o_1"};